import Pager from './pager';
import type { PagerProps } from './pager';
import ArrowsPager from './arrows-pager';

export { PagerProps, ArrowsPager };
export default Pager;
